export default $ => {
    $('[data-sticky="top"]').each(function () {
        $(this).sticky({topSpacing: 0, zIndex: 10});
    });

    $('[data-sticky="bottom"]').each(function () {
        const item = $(this);
        
        let itemTop, itemHeight, itemBottom;
        
        const calculateOriginalPosition = () => {
            itemTop = item.offset().top;
            itemHeight = item.outerHeight();
            itemBottom = itemTop + itemHeight;
        };

        const reposition = () => {
            let scrollTop = $(window).scrollTop();
            let winHeight = $(window).height();
            let scrollBottom = scrollTop + winHeight;
            
            if (itemBottom < scrollBottom) {
                // Normal
                item.css({position: '', bottom: '', left: '', right: ''});
                calculateOriginalPosition();
            } else {
                // Sticky
                item.css({position: 'fixed', bottom: 0, left: 0, right: 0});
            }
        };

        calculateOriginalPosition();
        reposition();
        
        if (window.addEventListener) {
            window.addEventListener('scroll', reposition, false);
            window.addEventListener('resize', reposition, false);
        } else if (window.attachEvent) {
            window.attachEvent('onscroll', reposition);
            window.attachEvent('onresize', reposition);
        } else {
            $(window).scroll(reposition);
            $(window).resize(reposition);
        }

    });
};



// WEBPACK FOOTER //
// ./assets/js/component/sticky.js